import React from 'react';
import i18next from 'i18next';
import Immutable from 'immutable';
import classNames from 'classnames';
import Truncate from 'react-truncate';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, ImageFromField } from '@uncinc/react-drupal-core';
import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_TABLET } from '@uncinc/uncinc-react-kitchen-sink/dist/Context/ViewportContext';

import { dateFormatter, getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const InterviewTeaserLarge = ({ entity, className, direction }) => {
  const classes = classNames(className, [
    'InterviewTeaserLarge',
    direction === 'right' ? 'reversed' : null,
  ]);

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], null);
  const author = entity.getIn(['field_author', 0, 'value']);
  const authorImage = entity.getIn(['field_author_image', 0]);
  const authorPosition = entity.getIn(['field_author_job_title', 0, 'value'], '');
  const url = getPathFromAlternativePaths(entity, ['interview', 'interview']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="InterviewTeaserLarge__content">
        <div className="col-12 col-md-3 col-lg-4 InterviewTeaserLarge__imageWrapper">
          <ImageFromField
            alt={author}
            lazyload={false}
            field={authorImage}
            imageStyles={Immutable.Map({
              [SCREEN_MOBILE]: 'teaser_image',
              [SCREEN_TABLET]: 'teaser_square',
              [SCREEN_NORMAL]: 'teaser_large',
            })}
          />
        </div>
        <div className="col-12 col-md-9 col-lg-8 InterviewTeaserLarge__contentWrapper">
          <div>
            <div className="InterviewTeaserLarge__theme">
              {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
                <div className="theme-labels">
                  <div className="theme-label">
                    {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                  </div>
                  {entity.getIn(['field_theme']).size > 1 && (
                    <div className="theme-label">
                      +{entity.getIn(['field_theme']).size - 1}
                    </div>
                  )}
                </div>
              ) : null}
              <span>{i18next.t('interview')}</span>
            </div>
            <div className="InterviewTeaserLarge__title">
              <h2>
                <Truncate lines={2}>
                  {title}
                </Truncate>
              </h2>
            </div>
            {body && (
              <div className="InterviewTeaserLarge__body">
                <Truncate lines={2}>
                  <WysiwygField
                    property="schema:text"
                    html={entity.getIn(['body', 0, 'processed'], '')}
                  />
                </Truncate>
              </div>
            )}
            <div className="InterviewTeaserLarge__date">
              {dateFormatter(entity.getIn(['created', 0, 'value'], new Date()))}
            </div>
          </div>
          <div className="InterviewTeaserLarge__author">
            <div className="InterviewTeaserLarge__author__details">
              <div className="InterviewTeaserLarge__author__details__name">
                {author}
              </div>
              {authorPosition && (
                <div className="InterviewTeaserLarge__author__details__job">
                  {authorPosition}
                </div>
              )}
            </div>
            <div className="InterviewTeaserLarge__date">
              {dateFormatter(entity.getIn(['created', 0, 'value'], new Date()))}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default InterviewTeaserLarge;
